(ns practitest.frontend.forms3.testset.instances
  (:require
   [practitest.frontend.components.tooltip :as tooltip]
   [practitest.frontend.components.icons :as icons]
   [practitest.frontend.common.i18n :refer [get-translation]]))

(defn locked-execution-icon
  "Renders a lock icon with a tooltip explaining that execution is locked"
  []
  [tooltip/mux-tooltip
   {}
   (get-translation "testset.instances.locked-for-execution" "Locked for execution")
   (fn [props]
     [:span props [icons/lock]])])